import React from 'react'
import PropTypes from 'prop-types'
import AmazonLink from '../amazon-link/amazon-link'
import { getWebpImage } from '../../utils'
import './product-card.scss'

const ProductCard = (props) => {
  const { product_name, subtitle, image, bottom_line, prons, amazon_link, featured } = props;
  const first5pros = prons ? prons.slice(0, 5) : null
  return (
    <section className="p-card">
      <div className={`p-card__label ${featured}`}>{featured.replace('-', ' ')}</div>
      <div className="p-card__image-wrap">
        <amp-img class="p-card__image" src={getWebpImage(image)} width="240" height="166" alt={product_name}>
          <amp-img fallback="" class="p-card__image" src={image} width="240" height="166" alt={product_name}>
          </amp-img>
        </amp-img>
      </div>
      <p className="p-card__title" >{product_name}</p>
      <p className="p-card__subtitle">{subtitle}</p>
      {bottom_line ? <p className="p-card__bottom-line">
        {bottom_line}
      </p> : (first5pros ? <ul className="p-card__pros-list">
        {first5pros.map((pron) => <li key={pron} className="p-card__pros-item">{pron.replace(/;/g, ',')}</li>)}
      </ul> : null)}
      <div className="p-card__buy-link">
        <AmazonLink link={amazon_link} title="View on Amazon" isBlack productName={product_name} />
      </div>
    </section>
  )
}


ProductCard.propTypes = {
  product_name: PropTypes.any.isRequired,
  subtitle: PropTypes.any,
  image: PropTypes.any.isRequired,
  bottom_line: PropTypes.any,
  prons: PropTypes.any,
  amazon_link: PropTypes.any.isRequired,
  featured: PropTypes.any.isRequired,
}

export default ProductCard;


// WEBPACK FOOTER //
// ./src/components/we-recommended/product-card.js